import { apiClient, getErrorMessage } from '../services/apiClient';
import { storageService } from '../services/storageService';
import { ENDPOINTS } from '../constants/endpoints';

export const login = async (email, password) => {
  try {
    const response = await apiClient.post(ENDPOINTS.AUTH.LOGIN, { email, password });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || 'Login failed. Please check your credentials.'
    );
  }
};

export const logout = async () => {
  try {
    const token = storageService.getToken();
    if (token) {
      await apiClient.post(ENDPOINTS.AUTH.LOGOUT);
    }
  } catch (error) {
    console.warn('Logout request failed:', error);
  } finally {
    storageService.clearAuth();
  }
};

export const refreshToken = async () => {
  try {
    const token = storageService.getToken();
    if (!token) {
      throw new Error('No token available');
    }
    const response = await apiClient.post(ENDPOINTS.AUTH.REFRESH);
    const { token: newToken } = response.data;
    storageService.setToken(newToken);
    return newToken;
  } catch (error) {
    storageService.clearAuth();
    throw new Error('Token refresh failed');
  }
};

export const verifyToken = async () => {
  try {
    const token = storageService.getToken();
    if (!token) {
      return false;
    }
    const response = await apiClient.post(ENDPOINTS.AUTH.VERIFY_TOKEN);
    return response.status === 200;
  } catch (error) {
    return false;
  }
};

export default apiClient;
